import { render, staticRenderFns } from "./GridDateColumn.vue?vue&type=template&id=ca3d8472&"
import script from "./GridDateColumn.vue?vue&type=script&lang=ts&"
export * from "./GridDateColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports